import { useQuery } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useFetchAgreementById(id_client: string) {
  return useQuery({
    queryKey: ['agreement'],
    queryFn: async () => {
      const response = await publicApi.get(`agreement/ativo/${id_client}`)

      if (response.data) {
        return response.data.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: !!id_client
  })
}
